var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      directives: [
        {
          name: "track",
          rawName: "v-track:click",
          value: {
            axId: "clicked_level_tag",
            axExtra: {
              learning_path_id: _vm.learningPath.id,
              learning_path_slug: _vm.learningPath.slug,
              version_name: _vm.learningPath.version_name
            }
          },
          expression:
            "{\n    axId: 'clicked_level_tag',\n    axExtra: {\n      learning_path_id: learningPath.id,\n      learning_path_slug: learningPath.slug,\n      version_name: learningPath.version_name,\n    },\n  }",
          arg: "click"
        }
      ],
      staticClass: "pill",
      style: "color: " + _vm.learningPath.color,
      attrs: { href: _vm.learningPath.url }
    },
    [
      _c("span", [
        _vm._v("\n    " + _vm._s(_vm.learningPath.title) + " · "),
        _c("span", { staticClass: "no-wrap" }, [
          _vm._v("Level " + _vm._s(_vm.learningPath.level_number))
        ])
      ]),
      _vm._v(" "),
      _c("ArrowIcon", {
        staticClass: "arrow-icon",
        attrs: { direction: "right", color: _vm.learningPath.color }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }